import { render } from "./loading.vue?vue&type=template&id=316919d2&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=316919d2&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316919d2"]])

export default __exports__